// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-field {
  position: relative;
  margin-bottom: 1rem;
}
.form-field ion-textarea {
  --padding-top: 0.875rem;
  --padding-start: 0.375rem;
  font-size: 1rem;
  font-weight: 500;
  border: 1px solid #E8E8E8;
  border-radius: 0.5rem;
  outline: none;
  padding: 0.125rem 0.75rem;
  background: none;
  z-index: 1;
  color: #171c25;
}
.form-field ion-textarea:focus {
  border-color: var(--ion-color-primary);
}
.form-field ::placeholder {
  color: #C4C4C4;
}
.form-field label.animate {
  background-color: #fff;
  color: #939fab;
  position: absolute;
  left: 0;
  top: 0;
  transition: transform 0.25s;
  transform: translate(1rem, 1rem);
}
.form-field label.animate.label-focused {
  transform: translate(0.8rem, -0.5rem);
  font-size: 14px;
  z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/app/components/form-field/textarea/textarea.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;AACF;AACE;EACE,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AACJ;AAEI;EACE,sCAAA;AAAN;AAGE;EACE,cAAA;AADJ;AAMI;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,2BAAA;EACA,gCAAA;AAJN;AAMM;EACE,qCAAA;EACA,eAAA;EACA,WAAA;AAJR","sourcesContent":[".form-field {\n  position: relative;\n  margin-bottom: 1rem;\n\n  ion-textarea {\n    --padding-top: 0.875rem;\n    --padding-start: 0.375rem;\n    font-size: 1rem;\n    font-weight: 500;\n    border: 1px solid #E8E8E8;\n    border-radius: .5rem;\n    outline: none;\n    padding: .125rem .75rem;\n    background: none;\n    z-index: 1;\n    color: #171c25;\n\n    // &:not(:placeholder-shown),\n    &:focus {\n      border-color: var(--ion-color-primary);\n    }\n  }\n  ::placeholder {\n    color: #C4C4C4;\n  }\n\n  label {\n\n    &.animate {\n      background-color: #fff;\n      color: #939fab;\n      position: absolute;\n      left: 0;\n      top: 0;\n      transition: transform .25s;\n      transform: translate(1rem, 1rem);\n\n      &.label-focused {\n        transform: translate(0.8rem, -0.5rem);\n        font-size: 14px;\n        z-index: 10;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
